// extracted by mini-css-extract-plugin
export default {"article_box":"Articles_article_box__5e4B-","image_area":"Articles_image_area__0H9I4"};